<!-- 设置模板 -->
<template>
  <div>
    <div style="display: flex; align-items: center; height: 28px">
      <div style="margin-right: 15px">当前模板：</div>
      <div
        style="margin-right: 15px; cursor: pointer; color: rgb(47, 136, 255)"
        @click="goTemplateInfo"
      >
        {{ infoData.template_name || "无" }}
      </div>
      <div
        v-if="infoData.template_tag"
        style="margin-right: 15px; cursor: pointer"
        class="tag-box"
        @click="goTemplateInfo"
      >
        {{ infoData.template_tag }}
      </div>
      <!-- <div
      @click="goTemplateInfo"
        style="margin-right: 15px; color: #2f88ff; cursor: pointer"
        v-if="calcDetailText"
      >
        查看模板详情
      </div> -->
      <div
        @click="changeTemp"
        style="color: #2f88ff; cursor: pointer; margin-right: 15px"
      >
        选择模板
      </div>
      <div @click="clearTemp" style="color: #2f88ff; cursor: pointer">
        清空模板设置
      </div>
    </div>

    <div
      style="margin-top: 10px; display: flex"
      :style="{ 'min-height': show_box_height + 'px' }"
    >
      <div class="scroll-big-box">
        <div
          style="width: 1100px; overflow-y: overlay; flex-shrink: 0"
          class="scroll-bar-box"
        >
          <div class="h5_div_box">
            <div style="margin-bottom: 12px">
              <span>模板变量：</span>
              <a-button @click="autoFillClick">自动填充小程序变量</a-button>
            </div>
            <div v-for="item in showReplaceData" :key="item.title">
              <div v-if="item.content.length > 0" style="padding-bottom: 20px">
                <div style="margin-bottom: 10px; padding-left: 20px">
                  {{ item.title }}
                </div>
                <div v-for="ite_z in item.content" :key="ite_z.label">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      margin-bottom: 10px;
                    "
                  >
                    <div style="width: 120px; text-align: right">
                      {{ ite_z.label }}：
                    </div>
                    <a-input
                      v-model="ite_z.value"
                      placeholder="请输入"
                      style="width: 800px"
                    />
                    <!-- <a-textarea v-model="ite_z.value" placeholder="请输入" style="width: 440px;" :auto-size="{ minRows: 1, maxRows: 3 }" /> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      style="
        padding: 15px;
        z-index: 9;
        background-color: #fff;
        display: flex;
        align-items: center;
        bottom: 0;
      "
    >
      <a-button
        @click="sendRequest()"
        :loading="search_button_loading"
        style="margin-left: 17px"
        type="primary"
        >保存设置</a-button
      >
      <div style="margin-left: 25px">
        提示：保存设置，将会修改菜单、关注后回复、关键词回复、延迟客服消息的设置。
      </div>
    </div>

    <a-modal
      title="更换模板"
      :visible="templat_visible"
      :confirm-loading="templat_confirmLoading"
      @ok="templatOk"
      @cancel="templatCancel"
    >
      <div>
        <a-select
          show-search
          style="width: 300px"
          placeholder="请选择模板"
          @change="handleChangeA"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          allowClear
          :value="temp_select_id"
          option-label-prop="label"
        >
          <a-select-option
            v-for="item in tempSelect"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          >
            {{ item.name
            }}<span style="font-size: 12px; color: #999; margin-left: 6px">{{
              item.type | formatText
            }}</span>
            <a-icon
              type="eye"
              style="font-size: 16px; margin-left: 4px; color: #81b337"
              v-if="item.status == 1"
            />
            <a-icon
              type="eye-invisible"
              style="font-size: 16px; margin-left: 4px"
              v-if="item.status == 0"
            />
          </a-select-option>
        </a-select>
      </div>
    </a-modal>

    <!-- 加载中 -->
    <div class="loading-box" v-if="loading">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import {
  templateReplaceWord,
  templateGzhGet,
  templateSelect,
  templateVarEdit,
  templateDelete,
} from "@/request/api";
import { AUTO_FILL_MAP } from "./tools.js";
export default {
  name: "pageSetTemplate_",
  props: [],
  data() {
    return {
      replaceWord: {}, // 替换词
      miniReplaceWord: {}, //小程序替换词
      totalreplaceWord: {},
      infoData: {}, // 页面详情数据
      h5KeyList: [],
      miniKeyList: [],
      search_button_loading: false,
      clear_button_loading: false,

      showReplaceData: [], // 展示模板你用到的变量
      showMiniReplaceData: [], //小程序模板用到的变量
      show_box_height: 500,

      r_gzh_id: null,

      templat_visible: false,
      templat_confirmLoading: false,
      tempSelect: [], // 模板下拉
      temp_select_id: undefined,
      change_select_flag: false, //投手更换了模板 但是未保存 此时也需要展示 详情按钮 因为列表的模板都是该投手创建
      appId: "",
      appName: "",
      gzhContentType: undefined,
      gzhAppid:""
    };
  },

  computed: {
    loading() {
      return this.search_button_loading || this.clear_button_loading;
    },
    calcDetailText() {
      const userId = Number(localStorage.getItem("user_id_storage") || -1);
      const _roles = localStorage.getItem("role_limits");
      const roles = _roles ? JSON.parse(_roles) : [];
      const id = this.infoData.admin_id;
      return (
        this.change_select_flag ||
        userId == id ||
        roles.includes(1) ||
        roles.includes(2) ||
        roles.includes(5)
      );
    },
  },
  filters: {
    formatText(val) {
      const list = {
        1: "H5",
        2: "H5+小程序",
        3: "小程序",
      };
      val = val || 1;
      return list[Number(val)];
    },
  },
  mounted() {
    let that = this;
    that.show_box_height =
      document.body.clientHeight -
      (65 + 20 * 2 + 20 + 43 + 52 + 28 + 25 + 77 + 12);
  },
  methods: {
    // 自动填充
    autoFillClick() {
      if (!this.appId) {
        this.$message.warning(`当前公众号未设置小程序`);
        return;
      }
      const _temp = JSON.parse(JSON.stringify(this.showReplaceData));
      const replaceId = this.gzhAppid ? this.gzhAppid : "{公众号appid}";
      for (let index = 0; index < _temp.length; index += 1) {
        const item = _temp[index];
        if (item.content.length > 0) {
          const key = item.title.replace(/[\d]/g, "");
          if (AUTO_FILL_MAP[key]) {
            const _info = AUTO_FILL_MAP[key];
            let _str = "";
            for (let indey = 0; indey < item.content.length; indey += 1) {
              const _item = item.content[indey];
              if (_item.label.includes("链接")) {
                _str = _item.value;
              }
              if (_item.label.includes("路径")) {
                let replace_str = _info.mini;
                replace_str = replace_str.replaceAll(
                  "{公众号appid}",
                  replaceId
                );
                if (_info.reg && _str) {
                  const result = _str.match(_info.reg);
                  if (result) {
                    const id = result[1];
                    replace_str = replace_str.replaceAll(_info.key, id);
                  }
                }
                _item.value = replace_str;
              }
              if (_item.label.includes("Appid")) {
                _item.value = this.appId;
              }
            }
          }
        }
      }
      this.showReplaceData = JSON.parse(JSON.stringify(_temp));
    },
    // 给ant design的select选择器重新设置定位
    getsPopupContainer(triggerNode) {
      // console.log("getsPopupContainer",triggerNode)
      return triggerNode.parentNode || document.body;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChangeA(e) {
      // console.log(option,`option`)
      this.temp_select_id = e;
    },
    getInfo(g_id) {
      let that = this;
      that.r_gzh_id = g_id;
      that.search_button_loading = true;
      that.change_select_flag = false;
      templateGzhGet({
        gzh_id: g_id,
      }).then((res) => {
        that.search_button_loading = false;
        that.infoData = res.data.data.info || {};
          that.appId = res.data.data.applets_appid;
          that.gzhAppid =  res.data.data.gzh_appid;
          that.appName = res.data.data.applets_name;
          that.gzhContentType = res.data.data.gzh_content_type;
        if (res.data.data.info) {
          // 表示有旧的内容
          const new_key = res.data.data.info.replace_word || [];
          const mini_new_key = res.data.data.info.applets_replace_word || [];
          that.h5KeyList = new_key;
          that.miniKeyList = mini_new_key;
          templateReplaceWord().then((re_t) => {
            // console.log("获取替换词", re_t);
            that.replaceWord = re_t.data.data.list;
            that.miniReplaceWord = re_t.data.data.applets_list;
            that.showReplaceData = that.tempHandle(
              Array.from(new Set([...new_key, ...mini_new_key])),
              "h5"
            );
            templateSelect().then((re_a) => {
              that.tempSelect = re_a.data.data.list;
            });
          });
        } else {
          that.infoData = {};
          that.showReplaceData = [];
          that.showMiniReplaceData = [];
          templateSelect().then((re_a) => {
            that.tempSelect = re_a.data.data.list;
          });

          templateReplaceWord().then((re_t) => {
            that.replaceWord = re_t.data.data.list;
            that.miniReplaceWord = re_t.data.data.applets_list;
          });
        }
      });
    },
    getTotalreplaceWord() {
      let result = {};
      if (this.replaceWord && this.miniReplaceWord) {
        for (let key in this.replaceWord) {
          result[key] = {
            ...this.replaceWord[key],
            ...this.miniReplaceWord[key],
          };
        }
      }
      this.totalreplaceWord = result;
    },
    // 讲所选模板下的替换词跟所有替换词进行匹配，然后进行显示
    tempHandle(new_key, type) {
      this.getTotalreplaceWord();
      if (type === "h5") {
        let that = this;
        let showVarData = [];
        for (let key in that.totalreplaceWord) {
          let obj = {
            title: key,
            content: [],
          };
          for (let ke_z in that.totalreplaceWord[key]) {
            for (let i = 0; i < new_key.length; i++) {
              if (ke_z == new_key[i]) {
                let z_obj = {
                  label: that.totalreplaceWord[key][ke_z],
                  variable: ke_z,
                  value: "",
                };
                obj.content.push(z_obj);
              }
            }
          }
          showVarData.push(obj);
        }

        if (Object.keys(that.infoData).length > 0) {
          // 在更换模板时，如果infoData为空，则没必要进行下一步
          showVarData.forEach((res) => {
            res.content.forEach((re_a) => {
              for (let ke_v in that.infoData.replace_content) {
                if (re_a.variable == ke_v) {
                  re_a.value = that.infoData.replace_content[ke_v] || "";
                }
              }
            });
          });
        }

        return showVarData;
      }
      if (type === "mini") {
        let that = this;
        let showVarData = [];
        for (let key in that.miniReplaceWord) {
          let obj = {
            title: key,
            content: [],
          };
          for (let ke_z in that.miniReplaceWord[key]) {
            for (let i = 0; i < new_key.length; i++) {
              if (ke_z == new_key[i]) {
                let z_obj = {
                  label: that.miniReplaceWord[key][ke_z],
                  variable: ke_z,
                  value: "",
                };
                obj.content.push(z_obj);
              }
            }
          }
          showVarData.push(obj);
        }
        if (Object.keys(that.infoData).length > 0) {
          // 在更换模板时，如果infoData为空，则没必要进行下一步
          showVarData.forEach((res) => {
            res.content.forEach((re_a) => {
              for (let ke_v in that.infoData.replace_content) {
                if (re_a.variable == ke_v) {
                  re_a.value = that.infoData.replace_content[ke_v] || "";
                }
              }
            });
          });
        }
        return showVarData;
      }
    },

    // 保存设置按钮
    sendRequest() {
      const item = this.tempSelect.find(
        (item) => item.id === this.temp_select_id
      );
      if (
        item &&
        ((item.type === 1 && this.gzhContentType !== 1) ||
          (item.type === 3 && this.gzhContentType !== 3))
      ) {
        this.$message.warning(`模板类型与公众号模式不匹配`);
        return;
      }

      
      let that = this;
      let replace_data = {};
      // let applets_replace_data = {};
      // h5站
      for (let i = 0; i < that.showReplaceData.length; i++) {
        for (let z = 0; z < that.showReplaceData[i].content.length; z++) {
          if (!that.showReplaceData[i].content[z].value) {
            that.$message.warning(
              `${that.showReplaceData[i].content[z].label}--内容不能为空`
            );
            return;
          }
          replace_data[that.showReplaceData[i].content[z].variable] =
            that.showReplaceData[i].content[z].value;
        }
      }

      let _replace_word = {};
      let _app_replace_word = {};

      for (let index = 0; index < that.h5KeyList.length; index += 1) {
        const key = that.h5KeyList[index];
        _replace_word[key] = replace_data[key];
      }
      for (let index = 0; index < that.miniKeyList.length; index += 1) {
        const key = that.miniKeyList[index];
        _app_replace_word[key] = replace_data[key];
      }
      this.$confirm({
        title: "确定要保存设置吗?",
        content: (h) => (
          <div style="color:red;">
            提示：保存设置，将会修改菜单、关注后回复、关键词回复、延迟客服消息的设置。
          </div>
        ),
        onOk() {
          that.search_button_loading = true;
          templateVarEdit({
            config_template_id: that.infoData.config_template_id,
            gzh_id: that.r_gzh_id,
            replace_word: _replace_word,
            applets_replace_word: _app_replace_word,
          })
            .then((res) => {
              that.search_button_loading = false;
              // console.log("设置变量", res);
              if (
                res.data.code == 0 ||
                res.data.code == 200 ||
                res.data.code == 8011
              ) {
                that.$message.success("保存设置成功");
              } else {
                try {
                  that.$error({
                    title: "错误提示",
                    content: `${res.data.msg}`,
                  });
                } catch (e) {
                  that.$message.error(`错误：${res.data.msg}`);
                }
              }
            })
            .catch((err) => {
              console.log("err", err);
              that.search_button_loading = false;
              // that.$message.error(`错误：${err}`)
              try {
                that.$error({
                  title: "错误提示",
                  content: `${err}`,
                });
              } catch (e) {
                that.$message.error(`错误：${err}`);
              }
            });
        },
        onCancel() {
          console.log("Cancel");
        },
        // class: 'test',
      });
    },
    // 查看详情
    goTemplateInfo() {
      if (this.calcDetailText) {
        const { href } = this.$router.resolve({
          path: "/gzhConfigTemplate",
          query: {
            info_id: this.temp_select_id || this.infoData.config_template_id,
            route_type: "menuManagement",
          },
        });
        window.open(href, "_blank");
      }
    },
    // 更换模板
    changeTemp() {
      if (this.infoData && this.calcDetailText) {
        this.temp_select_id = this.infoData.config_template_id;
      } else {
        this.temp_select_id = undefined;
      }
      this.templat_visible = true;
    },

    //清空所选模板
    clearTemp() {
      let that = this;
      this.$confirm({
        title: "提示",
        content: () => (
          <div style="color:red;">公众号各项设置会被情况，是否确定清空？</div>
        ),
        onOk() {
          that.clear_button_loading = true;
          templateDelete({
            gzh_id: that.r_gzh_id,
          })
            .then((res) => {
              that.clear_button_loading = false;

              if (
                res.data.code == 0 ||
                res.data.code == 200 ||
                res.data.code == 8011
              ) {
                that.$message.success("清空成功");
                that.getInfo(that.r_gzh_id);
              } else {
                try {
                  that.$error({
                    title: "错误提示",
                    content: `${res.data.msg}`,
                  });
                } catch (e) {
                  that.$message.error(`错误：${res.data.msg}`);
                }
              }
            })
            .catch((err) => {
              that.clear_button_loading = false;
              // that.$message.error(`错误：${err}`)
              try {
                that.$error({
                  title: "错误提示",
                  content: `${err}`,
                });
              } catch (e) {
                that.$message.error(`错误：${err}`);
              }
            });
        },
        onCancel() {
          console.log("Cancel");
        },
        // class: 'test',
      });
    },

    templatOk() {
      const item = this.tempSelect.find(
        (item) => item.id === this.temp_select_id
      );
       
      if (
        item &&
        ((item.type === 1 && this.gzhContentType !== 1) ||
          (item.type === 3 && this.gzhContentType !== 3))
      ) {
        this.$message.warning(`模板类型与公众号模式不匹配`);
        return;
      }
      let that = this;
      let tt_item = {};
      let new_key = []; // 最新模板的替换变量
      let mini_new_key = [];
      this.tempSelect.forEach((res) => {
        if (res.id == that.temp_select_id) {
          tt_item = res;
          new_key = res.replace_word;
          mini_new_key = res.applets_replace_word || [];
          that.h5KeyList = new_key;
          that.miniKeyList = mini_new_key;
        }
      });
      // console.log("最新模板的替换变量", new_key);
      that.infoData.template_name = tt_item.name;
      that.infoData.template_tag = tt_item.tags_list;
      that.infoData.config_template_id = tt_item.id;
      that.showReplaceData = that.tempHandle(
        Array.from(new Set([...new_key, ...mini_new_key])),
        "h5"
      );
      // that.showMiniReplaceData = that.tempHandle(mini_new_key, "mini");
      this.change_select_flag = true;
      this.templat_visible = false;
    },
    templatCancel() {
      this.templat_visible = false;
    },
  },
};
</script>

<style scoped>
.tag-box {
  background-color: #f2f3f5;
  color: #888;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 30px;
  cursor: default;
}

.handle-button {
  padding: 0 10px;
  height: 22px;
  line-height: 22px;
  box-sizing: border-box;
  border-radius: 2px;
  font-size: 12px;
  /* color: #40a9ff;
	border: 1px solid #40a9ff; */
  /* cursor: pointer; */

  /* color: #1890ff;
	border: 1px solid #1890ff; */

  /* color: #4E5969; */
  border: 1px solid #888888;
}
/* .handle-button:hover {
	background-color: #1890ff;
	color: #fff;
} */

/* 设置左侧列滚动条开始 */
/* 滚动条整体 */
.scroll-bar-box::-webkit-scrollbar {
  /* height决定横向scrollbar的高度，width决定纵向滚动条的宽度 */
  /* height:30px; */
  width: 7px;
  /* 默认：滚动条透明底色 */
  background-color: transparent;
}
/* 滚动条滑块 */
.scroll-bar-box::-webkit-scrollbar-thumb {
  /* 圆角 */
  border-radius: 10px;
  /* 滑块自身颜色 透明 */
  background-color: transparent;
}
/* 当鼠标hover时 */
.scroll-big-box:hover .scroll-bar-box::-webkit-scrollbar {
  /* 底色 */
  /* background-color:#f3f3f3 !important; */
}
.scroll-big-box:hover .scroll-bar-box::-webkit-scrollbar-thumb {
  /* 滑块颜色 */
  background-color: #999 !important;
}
.scroll-bar-box::-webkit-scrollbar {
  /* display:none; */
  background-color: transparent;
}
/* 设置左侧列滚动条结束 */
.ant-select-selection__placeholder {
  display: block !important;
}
.h5_div_box {
  margin-bottom: 12px;
  padding-top: 10px;
  padding-left: 10px;
}
</style>
